module.exports = __webpack_public_path__ + "static/bonsaiilabs_logo-10ed6b7f1c0017334334e8396db48e11.svg";